import React from 'react';
import { DocumentMagnifyingGlassIcon, ArrowUpTrayIcon } from '@heroicons/react/24/outline';

const ChallengerDevisHeader: React.FC = () => {
  return (
    <header className="mb-8">
      <div className="flex items-center justify-between">
        <div>
          <div className="flex items-center gap-3 mb-1">
            <div className="p-2 bg-violet-100 rounded-lg">
              <DocumentMagnifyingGlassIcon className="w-6 h-6 text-violet-600" />
            </div>
            <h1 className="text-3xl font-bold text-violet-700 leading-tight">
              Challenger un devis
            </h1>
          </div>
          <p className="mt-2 text-base text-gray-600">
            Comparez les prix de vos devis avec votre bibliothèque de prix de référence
          </p>
        </div>

        {/* Bouton import — visuellement actif, fonctionnalité à venir */}
        <div className="relative group">
          <button
            onClick={() => {}}
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-violet-600 rounded-lg hover:bg-violet-700 transition-colors"
          >
            <ArrowUpTrayIcon className="w-4 h-4" />
            Importer un devis
          </button>
          <div className="absolute bottom-full right-0 mb-2 hidden group-hover:block z-10">
            <div className="bg-gray-900 text-white text-xs rounded-lg px-3 py-2 whitespace-nowrap shadow-lg">
              Bientôt disponible
              <div className="absolute top-full right-4 border-4 border-transparent border-t-gray-900" />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default ChallengerDevisHeader;
